import {AxiosError} from 'axios';
import {GET_FILE_BULK_PROCESSING_STATUS_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_DOWNLOAD_ERROR_FILE_URL_QUERY_KEY} from '../../constants/queryKeys';
import {FileProcessingState} from '../../models/File';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: GetUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  refetchInterval?: number;
}

interface GetUrlResponse {
  errorMessage: string;
  numberOfRecords: number;
  presignUrl: string;
  status: FileProcessingState;
}

export const useGetFileProcessingStatusAndErrorFile = ({
                                                         uuid,
                                                         enabled = false,
                                                         onSuccess,
                                                         onError,
                                                         refetchInterval,
                                                       }: Input) => {
  const getUploadTemplateDownloadUrl = async () => {
    const res = await axiosClient.get<GetUrlResponse>(GET_FILE_BULK_PROCESSING_STATUS_URL(uuid));
    return res.data;
  };
  return useCustomQuery([GET_DOWNLOAD_ERROR_FILE_URL_QUERY_KEY], getUploadTemplateDownloadUrl, {
    onSuccess,
    onError,
    enabled,
    refetchInterval,
  });
};
